import PropTypes from 'prop-types';
import { FunctionField, SelectField, TextField, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { DetailsActionsPopover } from '@/components/global/buttons/DetailsActionsPopover.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { CustomBooleanField } from '@/components/global/fields/CustomBooleanField.jsx';
import { ParameterSubsetTree } from '@/components/parameter/tree/ParameterSubsetTree.jsx';
import { useDrawer } from '@/composables/useDrawer.js';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';
import { buildParameterName, parameterValueTypeChoices } from '@/constants/ParameterValueTypes.js';

const ParameterDetailsActions = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!permissions?.isAdmin || !record?.id) {
        return null;
    }

    return (
        <DetailsActionsPopover>
            <CustomEditModalButton label={translate('resources.parameter.labels.edit')} onOpen={() => openDrawer(record.id, 'parameter-edit')} />
        </DetailsActionsPopover>
    );
};

export const ParameterShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='parameter'
            canView={permissions => canViewDetails('parameter', permissions)}
            actions={<ParameterDetailsActions />}
            footer={<ParameterSubsetTree />}
            showChangeHistory
            historyFieldsSource='resources.parameter.fields'
        >
            <TextField source='name' label={translate('resources.parameter.fields.name')} />
            <TextField source='systemName' label={translate('resources.parameter.fields.systemName')} />
            <TextField source='description' label={translate('resources.parameter.fields.description')} />
            <SelectField source='type' choices={parameterValueTypeChoices(translate)} label={translate('resources.parameter.fields.type')} />
            <TextField source='value' label={translate('resources.parameter.fields.value')} />
            <FunctionField label={translate('resources.parameter.fields.parameter')} render={record => buildParameterName(record?.systemName, record?.type)} />
            <CustomBooleanField source='isActive' label={translate('resources.parameter.fields.isActive')} />
            <CustomBooleanField source='isSignificant' label={translate('resources.parameter.fields.isSignificant')} />
        </DetailsShow>
    );
};

ParameterShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
